module.exports = __webpack_public_path__ + "img/Skirt-Front-B4-Da-Fc-Gd-Hc-Id-Ja.4b706ffe.png";